import api from "./index";

export interface BillListParams {
  number?: string;
  companyId?: string;
  contractId?: string;
  responsibleId?: string;
  contractorId?: string;
  contractorType?: "juridical" | "physical";
  isPaid?: boolean;
  priceMin?: number;
  priceMax?: number;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  formedAtMin?: Date;
  formedAtMax?: Date;
  isArchive?: boolean;
  archivedAtMin?: Date;
  archivedAtMax?: Date;
  offset?: number;
  limit?: number;
  sort?: "createdAt" | "updatedAt" | "formedAt" | "number";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: BillListParams) => {
  return api.BillApi.listShort(
    params.number,
    params.companyId,
    params.contractId,
    params.responsibleId,
    params.contractorId,
    params.contractorType,
    params.isPaid,
    params.priceMin,
    params.priceMax,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.formedAtMin,
    params.formedAtMax,
    params.isArchive,
    params.archivedAtMin,
    params.archivedAtMax,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    params.options
  );
};
